export const ERROR_PATH = '/error' as const;
export const ROOT_PATH = '/checkout' as const;
export const RECEIPT_PATH = '/receipt' as const;
export const HISTORICAL_RECEIPT_PATH = '/historical-receipt' as const;
export const QUICK_CHECKOUT_PATH = '/quick-checkout';
export const REDIRECT_PATH = '/redirect' as const;
export const CHECKOUT_PATH = '/checkout';
